import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { FamilyTreeProvider } from './contexts/FamilyTreeContext';
import Login from './components/Login';
import FamilyTreePage from './pages/FamilyTreePage';
import { useAuth } from './contexts/AuthContext';
import './i18n';
import { useTranslation } from 'react-i18next';

// Protected route component
const ProtectedRoute: React.FC<{ element: React.ReactNode }> = ({ element }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  useEffect(() => {
    console.log("ProtectedRoute: Current auth state:", { user, loading, path: location.pathname });
  }, [user, loading, location]);
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user) {
    console.log("ProtectedRoute: No user found, redirecting to login");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  
  console.log("ProtectedRoute: User authenticated, rendering protected content");
  return <>{element}</>;
};

// Login route with redirect if already logged in
const LoginRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/family-tree';
  
  useEffect(() => {
    console.log("LoginRoute: Current auth state:", { user, loading, path: location.pathname });
  }, [user, loading, location]);
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (user) {
    console.log("LoginRoute: User already logged in, redirecting to:", from);
    return <Navigate to={from} replace />;
  }
  
  return <Login />;
};

function AppRoutes() {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route 
        path="/family-tree" 
        element={<ProtectedRoute element={<FamilyTreePage />} />} 
      />
      <Route path="/" element={<Navigate to="/family-tree" replace />} />
      <Route path="*" element={<div>{t('Page not found')}</div>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <FamilyTreeProvider>
        <Router>
          <div className="App">
            <AppRoutes />
          </div>
        </Router>
      </FamilyTreeProvider>
    </AuthProvider>
  );
}

export default App;
